import Icon from 'components/shared/Icon/Icon';
import Typography from 'components/shared/Typography/Typography';

const InformationCard = ({ icon, title, description }) => {
  return (
    <div className="flex min-w-[320px] flex-col items-center">
      <Icon icon={icon} />
      <div className="flex flex-col items-center gap-1 text-center">
        <Typography variant="p" size="medium" weight="medium">
          {title}
        </Typography>
        <Typography variant="p" color="neutral-700" size="small">
          {description}
        </Typography>
      </div>
    </div>
  );
};

export default InformationCard;
